import React from "react"

import {IonToggle} from "@ionic/react"

import './ListItemButtonIsEnabled.css'

interface props {
    disabled?: boolean
    item: any
    toggle: any
}


const ListItemButtonIsEnabled: React.FC<props> = ({ disabled, item, toggle }) => {
    const toggleEnabled = async (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        await toggle(item, { isEnabled: ev.currentTarget.checked })
    }

    return (
        <IonToggle
            aria-label='Enable or disable'
            justify="space-between"
            checked={item.isEnabled}
            enableOnOffLabels
            disabled={disabled}
            onClick={toggleEnabled}
            value="1">
        </IonToggle>
    )
}

export default ListItemButtonIsEnabled